import { SearchPublicationItems } from '@app/entities/models/search/search-publication-items.model';

export class SearchPublication {
  showViewAll!: boolean;
  items!: SearchPublicationItems[];
}
